import Pagination from '@mui/material/Pagination';
import { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2';
import { useDispatch } from "react-redux";
import { GetSession } from 'session-manager-beta';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, convertToNumber, handleDateChange, initializeFilterData } from "../CommonComponents/CustomHooks";
import { DateBox } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const CancelAndInitiatRefund = () => {
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const dispatch = useDispatch();
    const [result, setResult] = useState({ Data: [] });
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const LoginType = GetSession('cookies', 'loginUserType');
    const [Response, setResponse] = useState({});
    const [CheckAll, setCheckAll] = useState(false);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    let pqrDate = new Date()
    let dateArr = pqrDate?.toString()?.split(' ')
    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`

    const [formData, setFormData] = useState({
        "type": "AdminCancellationInitiate",
        "OnlinePaymentID": [],
        "fromDate": dateArr,
        "toDate": dateArr,
    })

    const handleClear = async () => {
        await setFormData({
            "type": "AdminCancellationInitiate",
            "OnlinePaymentID":[],
            "fromDate": dateArr,
            "toDate": dateArr,
            "pageIndex ":"1",
            "pageSize":"10",
        })
        await inputrefs.current['txtFromDate'].focus()
        setResponse({})
        setResult({ Data: [] })
        GetDataForAdminRefundProcessing();
    }

    const GetDataForAdminRefundProcessing = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            loginUserType: LoginType,
            "PageIndex": PageIndex.toString(),
        }
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Report/GetDataForAdminRefundProcessing', GetData)
        await dispatch(setSubLoading(false))
        await setResult(data)
        if (data.Status === 'UNAUTHORIZED' || data.Status === 'EXPIRED' || data.Status === 'ERROR') {
            await NotificationSound(data.Status, data.Message, data.Focus, inputrefs);
        }
        await dispatch(setSubLoading(false))
    }

    const handleChange1 = (event, value) => {
        GetDataForAdminRefundProcessing(value);
    };

    const handleSubmit = async () => {
        if (!Array.isArray(formData.OnlinePaymentID) || formData.OnlinePaymentID.length === 0) {
            await NotificationSound("ERROR", "Please select at least one record to cancel and initiate the refund. !", "txtFormDate", inputrefs);
        }
        else {
            await dispatch(setSubLoading(true))
            for (const paymentID of formData.OnlinePaymentID) {
                try {
                    let data = await ApiCall(`/api/Report/AdminInitiateCancellationRequest`, { ...formData, OnlinePaymentID: paymentID.toString() })
                    await NotificationSound(data.status, data.message, data.focus, inputrefs);
                    if (data.status === 'SUCCESS') {
                        await handleSubmitRefundTransaction(paymentID);
                    }
                }
                catch (error) {
                    console.error("Error during API call for OnlinePaymentID:", paymentID, error);
                }
            }
            await dispatch(setSubLoading(false))
        }
    };

    const handleSubmitRefundTransaction = async (paymentID) => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/SalesEntryAPI/RefundTransaction`, { Type: 'AdminCancellationInitiate', OnlinePaymentID: paymentID.toString() || '' })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, GetDataForAdminRefundProcessing());
    };
   
    const handleCheck = (id,OnlinePaymentID, i) => {
        const updatedTableData = result?.Data.map((item, index) => {
            if (index === i) {
                return {
                    ...item,
                    checkStatus: !item.checkStatus
                };
            }
            return item;
        });
        setResult(prevResult => ({
            ...prevResult,
            Data: updatedTableData
        }));
        const updatedOnlinePaymentID = updatedTableData
            .filter(item => item.checkStatus)
            .map(item => item.Checkbox);

        setFormData({ ...formData, OnlinePaymentID: updatedOnlinePaymentID });
    };

    const handleCheckAll = (value) => {
        setCheckAll(value);
        const updatedTableData = result?.Data.map(item => {
            return {
                ...item,
                checkStatus: value
            };
        });
        setResult(prevOnlinePaymentID => ({
            ...prevOnlinePaymentID,
            Data: updatedTableData
        }));
        const updatedOnlinePaymentID = value ? result?.Data.map(item => item.Checkbox) : [];
        setFormData({ ...formData, OnlinePaymentID: updatedOnlinePaymentID });
    };

    const handleSubmitRef = async () => {
        if (formData.OnlinePaymentID.length === 0 || formData.OnlinePaymentID.includes('0')) {
            await NotificationSound("ERROR", "Please select at least one record for Generate Policy. !", "txtFormDate", inputrefs);
        } else {
            await dispatch(setSubLoading(true));
            for (const paymentID of formData.OnlinePaymentID) {
                try {
                    let data = await ApiCall(`/api/SalesEntryAPI/GeneratePolicyNo`, { OnlinePaymentID: paymentID.toString() });
                    await NotificationSound(data.status, data.message, data.focus, inputrefs);
                } catch (error) {
                    console.error("Error during API call for OnlinePaymentID:", paymentID, error);
                }
            }
            await dispatch(setSubLoading(false));
        }
        handleClear();
    };


    useEffect(() => {
        GetDataForAdminRefundProcessing();
        inputrefs.current['txtFromDate'].focus()
        document.title = 'Cancel And Initiat Refund'
    }, []);
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    let PageName = 'CancelAndInitiatRefund'
    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{'Cancel And Initiate Refund'}</h6>
                </div>

                <div className='card-body'>
                    <div className="row">
                        <DateBox
                            id='txtFromDate'
                            inputrefs={inputrefs}
                            required={true}
                            label='From Date'
                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtToDate'].focus() };
                            }}

                        />
                        <DateBox
                            id='txtToDate'
                            inputrefs={inputrefs}
                            required={true}
                            label='To Date'
                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                        />
                    </div>
                    <div className='d-block mt-3 d-md-flex' >
                        <button
                            ref={ref => (inputrefs.current[`txtbtn`] = ref)}
                            onClick={GetDataForAdminRefundProcessing}
                            className="btn btn-rounded btn-primary">
                            <span className=" text-white me-2">
                                <i className="fa fa-search"></i>
                            </span>Search</button>
                        <button onClick={handleSubmit} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i></span>Cancel</button>
                        <button type="button"
                            onClick={() => {
                                Swal.fire({
                                    title: "Are you sure?",
                                    text: "Do you want to generate policy for this sale ?",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes",
                                    keydownListenerCapture: true,
                                    stopKeydownPropagation: false,
                                    didOpen: () => {
                                        document.addEventListener('keydown', function (event) {
                                            if (event.key === 'Y' || event.key === 'y') {
                                                Swal.clickConfirm();
                                            } else if (event.key === 'N' || event.key === 'n') {
                                                Swal.clickCancel();
                                            }
                                        });
                                    }
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        handleSubmitRef()
                                    }
                                });
                            }}
                            className="btn btn-rounded btn-success btn-sm"
                        >
                            <span className=" text-success me-2">
                                <i className="fa fa-save text-white color-success">
                                </i>
                            </span>Generate Policy
                        </button>
                        <button onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i></span>Reset</button>
                    </div>
                </div>

                <Table
                    PageName={PageName}
                    loading={loading}
                    handleCheck={handleCheck}
                    handleCheckAll={handleCheckAll}
                    handleFilter={() => {
                        GetDataForAdminRefundProcessing()
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    setFilterData={setFilterData}
                    tableData={result}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    handleSorting={handleSorting}
                    sortConfig={sortConfig}
                    Filter={false}
                    onlyFilterPage={true}
                />
            </div>
        </>

    )
}
export default CancelAndInitiatRefund;